module.exports = __webpack_public_path__ + "static/img/award1_active.b6ec53d.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award1_active.png
// module id = rN3Y
// module chunks = 7